<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'journals-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import {
  FinanceTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/finance/finance-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      CustomerSalesRepresentativeCode: undefined,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Journals",
        ScreenName: "Journals - All",
        selectedIndex: GetIndexByTabName("All"),
        tabs: FinanceTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "JournalList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Orders",
                message: "Get Started, Add an Order",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/journals/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              gridDataField: "JournalCode",
              label: "Journal Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: 120,
              showInColumnChooser: true,
              allowSearch: false,
              filterIndex: 0,
              type: "Integer",
              filterLabel: "Journal Code",
              filterDataField: "JournalCode",
            },
            {
              screenField: "JournalSearchText",
              dataField: "JournalSearchText",
              gridDataField: "JournalSearchText",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "Date",
              gridDataField: "Date",
              filterDataField: "Date",
              filterIndex: 1,
            },
            {
              screenField: "DateCreated",
              filterIndex: 2,
            },
            {
              screenField: "CreatedBy",
              //   gridDataField: "CreatedBy",
            },
            {
              screenField: "OrderStatus",
              gridDataField: "Status",
              filterDataField: "FriendlyStatus",
              filterIndex: 3,
              // filterDefaultValue: ["Completed"],
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "journals",
          mode: "review",
          idProperty: "JournalCode",
        });
      }
    },
  },

  created() {
    this.setLoading = true;
  },
};
</script>

<style lang="scss"></style>
